import { buildApiUrl } from "../utils/apiConfig";
import { jsonGet, jsonSend } from "../utils/http";

export interface CollegeWizardSearchParams {
    sport: string;
    division?: string;
    state?: string;
    minSize?: number;
    maxSize?: number;
    localeType?: string;
    type?: string;
    maxAcceptanceRate?: number;
    minAcceptanceRate?: number;
    page?: number;
    size?: number;
}

export interface CollegeWizardResult {
    ipedsId: string;
    name: string;
    state: string | null;
    city: string | null;
    type: string | null;
    size: number | null;
    acceptanceRate: number | null;
    avgNetCost: number | null;
    localeType: string | null;
    sport: string;
    division: string;
    gender: string;
}

export interface CollegeWizardPageResponse {
    content: CollegeWizardResult[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

export async function fetchProfileSport(): Promise<string> {
    const me = await jsonGet<any>(buildApiUrl("/api/athletes/me"));
    if (typeof me?.sport === "string") {
        return me.sport;
    }
    return me?.sport?.name ?? "";
}

export async function chatSearchColleges(
    message: string,
    priorUserMessage?: string,
    page = 0,
    size = 20,
): Promise<CollegeWizardPageResponse> {
    return jsonSend<CollegeWizardPageResponse>(buildApiUrl("/api/colleges/chat-search"), "POST", {
        message,
        priorUserMessage,
        page,
        size,
    });
}

export async function searchColleges(params: CollegeWizardSearchParams): Promise<CollegeWizardPageResponse> {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value).length > 0) {
            qs.set(key, String(value));
        }
    });
    return jsonGet<CollegeWizardPageResponse>(buildApiUrl(`/api/colleges/search?${qs.toString()}`));
}

export async function saveCollegeToMyList(username: string, college: CollegeWizardResult): Promise<any> {
    return jsonSend(buildApiUrl(`/api/colleges/athlete/${encodeURIComponent(username)}`), "POST", {
        id: Number.parseInt(college.ipedsId, 10),
        name: college.name,
        city: college.city,
        state: college.state,
        zip: null,
        schoolUrl: null,
        locale: college.localeType,
        size: college.size
    });
}
